import { useTranslation } from "react-i18next";

// Copy a Q/A pair to the clipboard with the shared "Powered by JuisciGPT"
// footer. The per-surface after-effect differs (general fires analytics, CWYOP
// shows a toast), so the caller passes it as `afterCopy` — only the copy-text
// format is shared here.
export function useCopyAnswer(): (
  question: string,
  answer: string,
  afterCopy: () => void
) => void {
  const { t } = useTranslation();
  return (question, answer, afterCopy) => {
    const copyText = `${question}\n\n${answer}\n\n${t("Powered by JuisciGPT")} - https://app.juisci.com`;
    void navigator.clipboard.writeText(copyText);
    afterCopy();
  };
}
